<template>
  <div class="sticky w-full z-[11]" :class="{'top-[4.25rem]':enableDashboardNav && !isPwaApp, 'top-16':!enableDashboardNav, 'sm:top-[7.5rem] top-[4rem]':isPwaApp}">
    <atoms-alert
      full-width
      class="text-center"
      size="p1"
      type="warning"
      :has-close="false"
      :rounded="false"
    >
      <IconsInfoCircle
        type="bold"
        :fill="semanticColorLookup('surface-on-surface')"
        class="inline w-4 align-bottom"
      />&nbsp;
      {{ instruction }}
      <molecules-dashboard-verification-tooltip class="!align-bottom" :is-guest-user="isGuestUser">
        <template #action-element>
          <span class="text-semantic-primary-default underline font-bold ml-1 cursor-pointer">Didn't get the email?</span>
        </template>
      </molecules-dashboard-verification-tooltip>
    </atoms-alert>
  </div>
</template>

<script setup>

defineOptions({
  name: 'MoleculesDashboardVerificationBar'
})

const props = defineProps({
  enableDashboardNav: {
    type: Boolean,
    default: true
  },
  isGuestUser: {
    type: Boolean,
    default: false
  },
  isPwaApp: {
    type: Boolean,
    default: false
  }
})

/*
 * Verification bar update on page refresh
 * @type {Store<"user", {authModuleParams: {}, userProfile: *|{}, signUpData: null, onBoardingFormData: {}, token: *|{}}, {isUserLoggedIn: function(*): *, getAuthUserState: function(*): *, getOnBoardingFormData: function(*): *, getUserProfile: function(*): *, isEmailVerified(): *}, {resetPassword(*): Promise<void>, forceLogout(): Promise<*|Promise<void>>, loader(boolean=): void, googleOneTapAuthInit(*): Promise<T>, profile(*): Promise<* extends (object & {then(onfulfilled: infer F, ...args: infer _): any}) ? (F extends ((value: infer V, ...args: infer _) => any) ? Awaited<V> : never) : *>, verifyUserDirectly(*): Promise<void>, resendVerification(): Promise<void>, setProfile(*): void, login(*): Promise<void>, finishSocialAuthentication(*): Promise<T>, checkUserExistence(*): Promise<void>, mergeUserAccounts(*): Promise<T>, saveUserProfileDetails(*): Promise<void>, forgotPassword(*): Promise<void>, logout(): Promise<*>, setToken(*): void, setSignUpData(*): void, setOnBoardingFormData(*): void, resetProfile(): void, socialAuthInit(*): Promise<T|*>, clearAuthUser(): void, register(*): Promise<* extends (object & {then(onfulfilled: infer F, ...args: infer _): any}) ? (F extends ((value: infer V, ...args: infer _) => any) ? Awaited<V> : never) : *>}>}
 */
const userStore = useUserStore()
const verificationCheckInterval = ref(null)
const instruction = computed(() => {
  return getKey(props.isGuestUser?'guestInstruction':'verificationInstruction',{
    'guestInstruction':'Check your email for instructions to verify your account to get full access',
    'verificationInstruction':'Check your email for instructions to verify your account to get full access'
  })
})
onMounted(() => {
  nextTick().then(() => {
    if (userStore.isUserLoggedIn && (!userStore.isEmailVerified||props.isGuestUser)) {
      userStore.profile()
      verificationCheckInterval.value = setInterval(() => {
        userStore.profile()
      }, 120000)
    }
  })
})
onUnmounted(() => {
  if (verificationCheckInterval.value) {
    clearInterval(verificationCheckInterval.value)
  }
})
</script>

<style scoped>

</style>
